export enum NotificationTypes {
  INFO = 'info',
  ISSUE = 'issue',
  NEUTRAL = 'neutral',
}
